import type { TypographyProps } from '@mui/material/Typography';
import Typography from '@mui/material/Typography';

type StatNumberProps = Omit<TypographyProps<'p'>, 'variant' | 'component'>;

export function StatNumber(props: StatNumberProps) {
  // eslint-disable-next-line jsx-a11y/heading-has-content
  return <Typography component="p" variant="h1" {...props} />;
}
